export default __webpack_public_path__ + "static/media/banner-default-img.0f3e84e9.svg";